import { TableRow, TableCell } from '@/components/ui/table';

export function SkeletonRow() {
  return (
    <TableRow>
      {Array.from({ length: 7 }).map((_, i) => (
        <TableCell key={i} className="py-3">
          <div
            className="h-4 rounded bg-muted animate-pulse"
            style={{ width: i === 2 ? '55%' : '70%' }}
          />
        </TableCell>
      ))}
    </TableRow>
  );
}
